<template>
  <div class="home">
    <div class="row">
      <div class="col-12 col-md-8">
        <!-- <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://c.streamhoster.com/embed/media/WKsdVu/mGVQTUXsid2/EA8ovAscrYk_5" frameborder="0" allow="autoplay; fullscreen" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe></div> -->
      </div>
      <div class="col-12 col-md-4 text-left">
        <h3 class="pt-40">Chat</h3>
        <chat-composer :user_id="this.user_id" :event_id="1"></chat-composer>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/Welcome.vue";

export default {
  name: "Home",
  props: ["user_id"],
  components: {
    // HelloWorld
  }
};
</script>
